module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "par view",
    style: ({
      backgroundImage: 'url(' + _vm.singlePhoto.thumburl + ')'
    })
  }, [_c('div', {
    staticClass: "close-but",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("✕")]), _vm._v(" "), _c('div', {
    staticClass: "user-caption"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-442fd6ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/photo.vue
// module id = 111
// module chunks = 0